import { useSyncExternalStore } from 'react';
import { prefersReducedMotion, subscribePrefersReducedMotion } from '../_helpers/reducedMotion.js';

/**
 * Whether the device asks for reduced motion (`prefers-reduced-motion:
 * reduce`), kept live: a component re-renders when the OS setting changes
 * while the page is open. Shared by stream effects (ENG-836) and meant for
 * the site-wide reduced motion work (ENG-837). See `_helpers/reducedMotion.js`.
 */
export const usePrefersReducedMotion = () =>
  useSyncExternalStore(subscribePrefersReducedMotion, prefersReducedMotion, () => false);

export default usePrefersReducedMotion;
